var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: { title: "客户经理项目人账号信息", width: 60 },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm.$globalSpin
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
      _c(
        "Form",
        {
          ref: "userForm",
          staticClass: "small-form",
          attrs: {
            model: _vm.userForm,
            rules: _vm.ruleValidate,
            "label-position": "top",
          },
        },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "登录帐号", prop: "userName" } },
                    [
                      _c("Input", {
                        attrs: {
                          placeholder: "请以P开头",
                          readonly:
                            _vm.formEditMode === _vm.FORM_EDIT_MODE_MODIFY,
                        },
                        model: {
                          value: _vm.userForm.userName,
                          callback: function ($$v) {
                            _vm.$set(_vm.userForm, "userName", $$v)
                          },
                          expression: "userForm.userName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "角色", prop: "roleUuid" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: {
                            placeholder: "请选择角色",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.userForm.roleUuid,
                            callback: function ($$v) {
                              _vm.$set(_vm.userForm, "roleUuid", $$v)
                            },
                            expression: "userForm.roleUuid",
                          },
                        },
                        _vm._l(_vm.roleIdList, function (item, index) {
                          return _c(
                            "Option",
                            {
                              key: item.roleUuid,
                              attrs: { value: item.roleUuid },
                            },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "姓名", prop: "userPersonName" } },
                    [
                      _c("Input", {
                        attrs: { placeholder: "请输入姓名" },
                        model: {
                          value: _vm.userForm.userPersonName,
                          callback: function ($$v) {
                            _vm.$set(_vm.userForm, "userPersonName", $$v)
                          },
                          expression: "userForm.userPersonName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "手机", prop: "userPhone" } },
                    [
                      _c("Input", {
                        attrs: { placeholder: "请输入手机号" },
                        model: {
                          value: _vm.userForm.userPhone,
                          callback: function ($$v) {
                            _vm.$set(_vm.userForm, "userPhone", $$v)
                          },
                          expression: "userForm.userPhone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "状态" } },
                    [
                      _c(
                        "RadioGroup",
                        {
                          attrs: { type: "button" },
                          model: {
                            value: _vm.userForm.userStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.userForm, "userStatus", $$v)
                            },
                            expression: "userForm.userStatus",
                          },
                        },
                        _vm._l(_vm.approvalSource, function (item) {
                          return _c(
                            "Radio",
                            { key: item.val, attrs: { label: item.val } },
                            [
                              _vm._v(
                                _vm._s(item.label) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "部门", prop: "department" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { clearable: "", filterable: "" },
                          model: {
                            value: _vm.userForm.departmentUuid,
                            callback: function ($$v) {
                              _vm.$set(_vm.userForm, "departmentUuid", $$v)
                            },
                            expression: "userForm.departmentUuid",
                          },
                        },
                        _vm._l(_vm.departmentList, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.departmentUuid,
                              attrs: { value: item.departmentUuid },
                            },
                            [
                              _vm._v(
                                _vm._s(item.departmentName) +
                                  "-" +
                                  _vm._s(item.departmentContact)
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.formEditMode === _vm.FORM_EDIT_MODE_CREATE
                ? _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "密码" } },
                        [
                          _c("Input", {
                            attrs: {
                              placeholder: "请输入密码",
                              type: "password",
                            },
                            model: {
                              value: _vm.password,
                              callback: function ($$v) {
                                _vm.password = $$v
                              },
                              expression: "password",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formEditMode === _vm.FORM_EDIT_MODE_CREATE
                ? _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "密码确认" } },
                        [
                          _c("Input", {
                            attrs: {
                              placeholder: "请输入密码确认",
                              type: "password",
                            },
                            model: {
                              value: _vm.passwordConfirm,
                              callback: function ($$v) {
                                _vm.passwordConfirm = $$v
                              },
                              expression: "passwordConfirm",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "Button",
            { attrs: { type: "primary" }, on: { click: _vm.onSave } },
            [_vm._v("确认")]
          ),
          _c(
            "Button",
            { attrs: { type: "error" }, on: { click: _vm.onCancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }